module.exports = __webpack_public_path__ + "img/404.388b1996.png";